<template>
  <el-drawer :visible.sync="visible" title="通知" :size="1073" class="notify-page_drawer" :destroy-on-close="true">
    <div class="notify-container">
      <!-- 左侧通知分类 -->
      <div class="left-menu">
        <div class="notify-menu">
          <template v-for="(item, index) in notifyTypeList">
            <div v-if="item.children && item.children.length > 0" :key="item.title + index" class="menu-group">
              <div class="menu-group-title" :class="{ active: activeType === item.title }" @click="handleTypeSelect(item)">
                <span>
                  {{ item.title }}
                  <el-badge is-dot :hidden="fatherHaveUnread(item.children)" class="dot" />
                </span>
              </div>
              <div class="menu-group-items">
                <div
                  v-for="itemx in item.children"
                  :key="itemx.title"
                  class="menu-item"
                  :class="{ active: activeType === itemx.title }"
                  @click="handleTypeSelect(itemx)"
                >
                  <span>
                    {{ itemx.title }}
                    <el-badge is-dot :hidden="itemx.unreadCount <= 0" class="dot" />
                  </span>
                </div>
              </div>
            </div>
            <div
              v-else
              :key="'menu-' + item.title + index"
              class="menu-item"
              :class="{ active: activeType === item.title }"
              @click="handleTypeSelect(item)"
            >
              <span>
                {{ item.title }}
                <el-badge is-dot :hidden="item.unreadCount <= 0" class="dot" />
              </span>
            </div>
          </template>
        </div>
      </div>

      <!-- 右侧内容区 -->
      <div v-loading="loading" class="right-content">
        <!-- 搜索栏 -->
        <div class="search-bar">
          <el-input v-model="searchText" placeholder="请输入关键词" clearable class="search-input" size="small" @keyup.enter.native="getNotifyList" />
          <CtDatePicker v-model="dateRange" placeholder="请输入日期" :show-time="true" :type="'daterange'"></CtDatePicker>
          <el-button type="primary" size="small" @click="getNotifyList">查询</el-button>
          <template v-if="selectTypeClass.unreadCount && selectTypeClass.unreadCount > 0">
            <el-divider direction="vertical"></el-divider>
            <i class="iconfont icon-Frame-2 hander" @click="handleReadAll">一键已读</i>
          </template>
        </div>

        <!-- 通知列表 -->
        <div v-if="notifications.length > 0" class="notify-page_list">
          <div v-for="item in notifications" :key="item.id" class="notify-item">
            <div class="notify-header">
              <span class="notify-title">
                {{ item.title }}
              </span>
              <el-badge is-dot :hidden="item.isRead == 1">
                <span class="notify-time">{{ item.createTime }}</span>
              </el-badge>
              <i v-if="item.isRead != 1" class="iconfont icon-gouxuan1 read-hander" @click="handleRead(item)">点击已读</i>
            </div>
            <div v-viewer class="notify-content" v-html="item.content"></div>
          </div>
        </div>
        <div v-else class="notify-page_list">暂无通知</div>
        <!-- 分页 -->
        <div class="pagination-container">
          <el-pagination
            :current-page="formData.current"
            :page-size="formData.size"
            :total="total"
            layout="total, prev, pager, next"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { apiGetNotifyType, apiGetNotifyList, apiReadAllNotify, apiReadUserSingleMessage } from "@/api/user"
import store from "@/store"
export default {
  name: "NotifyPage",

  data() {
    return {
      visible: false,
      searchText: "",
      dateRange: [],
      activeType: "全部通知",
      total: 100,
      notifications: [],
      notifyTypeList: [],
      selectTypeClass: {},
      loading: true,
      formData: {
        size: 10,
        current: 1,
        param: {
          content: "",
          msgTypes: [],
          startTime: "",
          endTime: ""
        }
      }
    }
  },
  watch: {
    visible: {
      async handler(val) {
        if (val) {
          await this.getNotifyType()
          this.activeType = "全部通知"
          this.formData.param.msgTypes = this.notifyTypeList[0].sysIds
          this.selectTypeClass = this.notifyTypeList[0]
          this.formData.current = 1
          this.formData.size = 10
          this.total = 0
          this.searchText = ""
          this.dateRange = []
          this.getNotifyList()
        } else {
          store.dispatch("user/getUnreadNotifyCount")
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    handleTypeSelect(item) {
      this.activeType = item.title
      this.selectTypeClass = item
      this.formData.param.msgTypes = item.sysIds
      // 重制页数和大小
      this.formData.current = 1
      this.formData.size = 10
      this.getNotifyList()
    },

    markAsRead(id) {
      const notification = this.notifications.find(item => item.id === id)
      if (notification) {
        notification.isRead = true
      }
    },

    handlePageChange(page) {
      this.formData.current = page
      // 获取对应页码的数据
      this.getNotifyList()
    },

    handleBusinessClick() {
      this.businessExpanded = !this.businessExpanded
    },
    fatherHaveUnread(children) {
      let num = 0
      if (children && children.length > 0) {
        children.forEach(item => {
          num = num + item.unreadCount * 1
        })
      }
      return num <= 0
    },
    // 获取通知类型
    getNotifyType() {
      return new Promise(resolve => {
        apiGetNotifyType().then(res => {
          // 对数据进行归类，分为全部通知，业务通知，系统通知
          const notifyTypeList = []
          const allObj = {
            title: "全部通知",
            sysIds: [],
            unreadCount: 0
          }
          const businessObj = {
            title: "业务通知",
            sysIds: [],
            unreadCount: 0,
            children: []
          }
          const systemObj = {
            title: "系统通知",
            sysIds: [],
            unreadCount: 0
          }
          res.data.forEach(item => {
            allObj.sysIds.push(item.id)
            allObj.unreadCount += item.unreadCount
            if (item.typeCode === "system") {
              systemObj.sysIds.push(item.id)
              systemObj.unreadCount += item.unreadCount
            } else {
              businessObj.sysIds.push(item.id)
              businessObj.children.push({
                title: item.typeName,
                sysIds: [item.id],
                id: item.id,
                unreadCount: item.unreadCount
              })
              businessObj.unreadCount += item.unreadCount
            }
          })
          notifyTypeList.push(allObj)
          notifyTypeList.push(businessObj)
          notifyTypeList.push(systemObj)
          this.notifyTypeList = notifyTypeList
          resolve()
        })
      })
    },
    // 获取通知列表
    getNotifyList() {
      // 处理选择的类型
      // 处理搜索内容
      this.formData.param.content = this.searchText
      // 处理日期格式
      this.formData.param.startTime = this.dateRange[0]
      this.formData.param.endTime = this.dateRange[1]
      this.loading = true
      apiGetNotifyList(this.formData).then(res => {
        this.notifications = res.data.records || []
        this.total = res.data.total || 0
        this.loading = false
      })
    },
    // 一键已读
    handleReadAll() {
      apiReadAllNotify({ msgTypeIdList: this.selectTypeClass.sysIds || [] }).then(async res => {
        this.selectTypeClass.unreadCount = 0
        await this.getNotifyType()
        this.getNotifyList()
      })
    },
    // 点击已读
    handleRead(item) {
      apiReadUserSingleMessage({ id: item.id }).then(async res => {
        // 清空对应的类型unread
        // this.notifyTypeList.forEach(typeItem => {
        //   if (typeItem.id == item.msgType) {
        //     typeItem.unreadCount--
        //   }
        //   if (typeItem.children) {
        //     typeItem.children.forEach(typeItemx => {
        //       if (typeItemx.id == item.msgType) {
        //         typeItemx.unreadCount--
        //       }
        //     })
        //   }
        // })
        await this.getNotifyType()
        this.getNotifyList()
        this.selectTypeClass.unreadCount--
      })
    }
  }
}
</script>

<style>
.notify-page_drawer .el-drawer__header {
  margin-bottom: 0 !important;
  margin-bottom: 0; /* 双重声明提高优先级 */
}
</style>

<style scoped lang="scss">
.notify-container {
  display: flex;
  height: 100%;
}

.left-menu {
  width: 220px;
  border-right: 1px solid #eee;
  height: 100%;
  flex-shrink: 0;
}

.right-content {
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  align-items: center;
  .hander {
    cursor: pointer;
    font-size: 14px;
    color: #525253;
    &:hover {
      color: #409eff;
    }
  }
}

.search-input {
  width: 200px;
}

.notify-page_list {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.notify-item {
  border-bottom: 1px solid #eee;
  padding: 12px;
}

.notify-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
  .read-hander {
    cursor: pointer;
    font-size: 14px;
    color: #409eff;
  }
}

.notify-title {
  font-weight: bold;
}

.notify-time {
  color: #999;
  font-size: 14px;
}

.notify-content {
  color: #666;
  margin-bottom: 8px;
  ::v-deep img {
    max-width: 300px !important;
  }
}

.notify-footer {
  display: flex;
  justify-content: flex-end;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

/* 左侧菜单样式 */
.notify-menu {
  padding: 16px 0;
  height: 100%;
  overflow-y: auto;
}

.menu-item {
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  span {
    position: relative;
    .dot {
      position: absolute;
      right: -10px;
      top: 0px;
    }
  }
}

.menu-item:hover {
  background-color: #f5f7fa;
}

.menu-item.active,
.menu-group-title.active {
  background-color: #ecf5ff;
  color: #409eff;
}

.menu-group {
  border-bottom: 1px solid #eee;
  margin: 8px 0;
}

.menu-group-title {
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.1s;
  font-weight: 500;
}

.menu-group-title:hover {
  background-color: #f5f7fa;
}

.menu-group-items {
  background-color: #fafafa;
}

.menu-group-items .menu-item {
  padding-left: 40px;
  font-size: 13px;
}
</style>
